import {
    DEALER_LICENCE,
    EQUIPMENT_INFORMATION,
    DEALERS_CONTACT_PERSON_PARTICULARS,
    DEALERS_LICENCE_MAILING_ADDRESS,
    OTHER_DETAILS,
    RADIO_INFORMATION,
    EQUIPMENT_DETAILS_FREQUENCY,
    IMDA_TS_SECURITY_REQUIREMENTS_FOR_RESIDENTIAL_GATEWAYS,
    IMDA_TS_RG_SEC_4_1_LOGIN_CREDENTIALS_MANAGEMENT,
    IMDA_TS_RG_SEC_4_1_1_FACTORY_PRE_LOADED_LOGIN_CREDENTIALS,
    IMDA_TS_RG_SEC_4_2_DEVICE_SETUP_AND_ADMINISTRATION,
    IMDA_TS_RG_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS,
    IMDA_TS_RG_SEC_4_2_2_INITIAL_SETUP_HANDLING,
    IMDA_TS_RG_SEC_4_2_5_DEVICE_MANAGEMENT_INTERFACE,
    IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES,
    IMDA_TS_RG_SEC_4_4_WIRELESS_ACCESS_PROTECTION,
    IMDA_TS_RG_SEC_4_6_VALIDATION_OF_DATA_INPUTS,
    IMDA_TS_RG_SEC_4_7_VULNERABILITIES_REPORTING,
    CYBERSECURITY_LABELLING_SCHEME,
    IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION,
    IMDA_TS_PABX_SEC_4_1_LOGIN_CREDENTIALS_MANAGEMENT,
    IMDA_TS_PABX_SEC_4_1_1_FACTORY_PRE_LOADED_LOGIN_CREDENTIALS,
    IMDA_TS_PABX_SEC_4_1_2_MINIMUM_PASSWORD_LENGTH,
    IMDA_TS_PABX_SEC_4_2_DEVICE_SETUP_AND_ADMINISTRATION,
    IMDA_TS_PABX_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS,
    IMDA_TS_PABX_SEC_4_2_2_INITIAL_SETUP_HANDLING,
    IMDA_TS_PABX_SEC_4_2_3_AUTHENTICATION_HANDLING,
    IMDA_TS_PABX_SEC_4_2_4_PASSWORD_HANDLING,
    IMDA_TS_PABX_SEC_4_2_5_DEVICE_MANAGEMENT_INTERFACE,
    IMDA_TS_PABX_SEC_4_3_FIRMWARE_UPDATES,
    IMDA_TS_PABX_SEC_4_4_DATA_PROTECTION,
    IMDA_TS_PABX_SEC_4_4_1_DATA_CONFIDENTIALITY,
    IMDA_TS_PABX_SEC_4_4_2_EVENT_NOTIFICATION,
    IMDA_TS_PABX_SEC_4_4_3_DATA_BACKUP,
    IMDA_TS_PABX_SEC_4_5_SECURING_THE_TRUNK,
    IMDA_TS_PABX_SEC_4_6_VALIDATION_OF_DATA_INPUTS,
    IMDA_TS_PABX_SEC_4_7_REPORTING,
    IMDA_TS_PABX_SEC_4_7_1_REPORT_ON_CALLS,
    IMDA_TS_PABX_SEC_4_7_2_VULNERABILITY_REPORTING,
    IMDA_TS_RG_SEC_4_2_2_AUTHENTICATION_HANDLING,
    IMDA_TS_RG_SEC_4_2_3_CREDENTIALS_HANDLING,
    IMDA_TS_RG_SEC_4_4_DATA_PROTECTION,
    IMDA_TS_RG_SEC_4_5_LEVEL2_REQUIREMENTS,
    IMDA_TS_RG_SEC_4_1_MINIMUM_PASSWORD_STRENGTH
} from 'common/application.const/Licence/MyLicence/ESERLicence';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';

export const formatESER = async (licenceDetails: any, caseTypeID: string, application?: string) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;

    let imdaSpecNoDesc = [];
    let networkConnection = [];
    let equipmentDetailsFrequency = [];

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    if (
        licenceDetails &&
        licenceDetails?.equipmentInfo[0]?.imdaSpecNoDescriptionList &&
        licenceDetails?.equipmentInfo[0]?.imdaSpecNoDescriptionList.length > 0
    ) {
        imdaSpecNoDesc = licenceDetails?.equipmentInfo[0]?.imdaSpecNoDescriptionList?.map((i: any) => i.mixedValue);
    }

    if (
        licenceDetails &&
        licenceDetails?.equipmentInfo[0]?.networkConnection &&
        licenceDetails?.equipmentInfo[0]?.networkConnection.length > 0
    ) {
        networkConnection = licenceDetails?.equipmentInfo[0]?.networkConnection?.map((i: any) => i.mixedValue);
    }

    if (
        licenceDetails &&
        licenceDetails?.equipmentInfo[0]?.equipmentDetailsFrequency &&
        licenceDetails?.equipmentInfo[0]?.equipmentDetailsFrequency.length > 0
    ) {
        equipmentDetailsFrequency = licenceDetails?.equipmentInfo[0]?.equipmentDetailsFrequency?.map((value: any, i: number) => ({
            sn: value?.rowId,
            'frequency-band': value?.frequencyBandMaximumRadiatedPowerField ?? '-'
        }));
    }

    licence = {
        id: 'enhanced-simplified-equipment-registration',
        formID: 'enhanced-simplified-equipment-registration',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {
            [`${DEALER_LICENCE}-dealer-licence-no`]: licenceDetails?.applicationInformation?.dealerLicenceNo ?? '-',
            [`${DEALER_LICENCE}-dealer-licence-company-name`]: licenceDetails?.applicationInformation?.dealerSLicenceCompanyName ?? '-',
            [`${DEALER_LICENCE}-scheme-type`]: licenceDetails?.applicationInformation?.schemeType ?? '-',
            [`${DEALER_LICENCE}-brand-trade-name`]: licenceDetails?.equipmentInfo[0]?.brandTradeName ?? '-',
            [`${DEALER_LICENCE}-model-no`]: licenceDetails?.equipmentInfo[0]?.modelNo ?? '-',
            [`${DEALER_LICENCE}-equipment-description`]: licenceDetails?.equipmentInfo[0]?.equipmentDescription ?? '-',

            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-same-as-applicant-particulars`]:
                licenceDetails?.contactPersonParticulars?.sameAsApplicantParticulars ?? '-',
            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-name`]: licenceDetails?.contactPersonParticulars?.name ?? '-',
            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-designation`]: licenceDetails?.contactPersonParticulars?.designation ?? '-',
            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-email`]: licenceDetails?.contactPersonParticulars?.email ?? '-',
            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-office-tel-number`]: licenceDetails?.contactPersonParticulars?.officeTelNumber ?? '-',
            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-mobile-number`]: licenceDetails?.contactPersonParticulars?.mobileNumber ?? '-',
            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-fax-number`]: licenceDetails?.contactPersonParticulars?.faxNumber ?? '-',

            [`${DEALERS_LICENCE_MAILING_ADDRESS}-same-as-applicant-particulars`]:
                licenceDetails?.contactPersonAddress?.sameAsApplicantAddress ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-building-name`]: licenceDetails?.contactPersonAddress?.address?.buildingName ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-postal-code`]: licenceDetails?.contactPersonAddress?.address?.postalCode ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-street-name`]: licenceDetails?.contactPersonAddress?.address?.streetName ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-block-house-no`]: licenceDetails?.contactPersonAddress?.address?.blockNo ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-floor-level`]: licenceDetails?.contactPersonAddress?.address?.floor ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-unit`]: licenceDetails?.contactPersonAddress?.address?.unit ?? '-',

            [`${OTHER_DETAILS}-other-details`]: licenceDetails?.otherDetails ?? '-',
            [`${OTHER_DETAILS}-public-contact-no`]: licenceDetails?.otherDetails?.publicContactNo ?? '-',
            [`${OTHER_DETAILS}-remarks`]: licenceDetails?.otherDetails?.remarks ?? '-',

            [`${EQUIPMENT_INFORMATION}-imda-spec-no-desc`]: imdaSpecNoDesc ?? [],
            [`${EQUIPMENT_INFORMATION}-list-of-telecommunication-interface-cards`]:
                licenceDetails?.equipmentInfo[0]?.listOfTelecommunicationInterfaceCards ?? '-',
            [`${EQUIPMENT_INFORMATION}-network-connection`]: networkConnection ?? [],

            [`${RADIO_INFORMATION}-equipment`]: licenceDetails?.equipmentInfo[0]?.equipment ?? '-',
            [`${RADIO_INFORMATION}-equipment-category`]: licenceDetails?.equipmentInfo[0]?.equipmentCategory ?? '-',
            [`${RADIO_INFORMATION}-equipment-type`]: licenceDetails?.equipmentInfo[0]?.equipType ?? '-',

            [`${EQUIPMENT_DETAILS_FREQUENCY}-list`]: equipmentDetailsFrequency ?? [],

            [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_RESIDENTIAL_GATEWAYS}-residential-gateways`]:
                            licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2 ?? '-',
            
            [`${IMDA_TS_RG_SEC_4_1_1_FACTORY_PRE_LOADED_LOGIN_CREDENTIALS}-4-1-1`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req411 ?? '-',

            [`${IMDA_TS_RG_SEC_4_1_MINIMUM_PASSWORD_STRENGTH}-4-1-a`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req41A ?? '-',
            [`${IMDA_TS_RG_SEC_4_1_MINIMUM_PASSWORD_STRENGTH}-4-1-b`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req41B ?? '-',
            [`${IMDA_TS_RG_SEC_4_1_MINIMUM_PASSWORD_STRENGTH}-4-1-c`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req41C ?? '-',

            [`${IMDA_TS_RG_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-a`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req421A ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-b`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req421B ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-c`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req421C ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-d`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req421D ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-e`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req421E ?? '-',

            [`${IMDA_TS_RG_SEC_4_2_2_INITIAL_SETUP_HANDLING}-4-2-2`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req422 ?? '-',

            [`${IMDA_TS_RG_SEC_4_2_2_AUTHENTICATION_HANDLING}-4-2-2-a`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req422A ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_2_AUTHENTICATION_HANDLING}-4-2-2-b`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req422B ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_2_AUTHENTICATION_HANDLING}-4-2-2-c`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req422C ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_2_AUTHENTICATION_HANDLING}-4-2-3-d`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req423D ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_2_AUTHENTICATION_HANDLING}-4-2-3-e`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req423E ?? '-',

            [`${IMDA_TS_RG_SEC_4_2_3_CREDENTIALS_HANDLING}-4-2-3-a`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req423A ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_3_CREDENTIALS_HANDLING}-4-2-3-b`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req423B ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_3_CREDENTIALS_HANDLING}-4-2-3-c`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req423C ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_3_CREDENTIALS_HANDLING}-4-2-3-d`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req423D ?? '-',

            [`${IMDA_TS_RG_SEC_4_2_5_DEVICE_MANAGEMENT_INTERFACE}-4-2-5`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req425 ?? '-',

            [`${IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES}-4-3-a`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req43A ?? '-',
            [`${IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES}-4-3-b`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req43B ?? '-',
            [`${IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES}-4-3-c`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req43C ?? '-',
            [`${IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES}-4-3-d`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req43D ?? '-',
            [`${IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES}-4-3-e`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req43E ?? '-',
            [`${IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES}-4-3-f`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req43F ?? '-',
            [`${IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES}-4-3-g`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req43G ?? '-',

            [`${IMDA_TS_RG_SEC_4_4_WIRELESS_ACCESS_PROTECTION}-4-4-a`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req44A ?? '-',
            [`${IMDA_TS_RG_SEC_4_4_WIRELESS_ACCESS_PROTECTION}-4-4-b`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req44B ?? '-',
            [`${IMDA_TS_RG_SEC_4_4_WIRELESS_ACCESS_PROTECTION}-4-4-c`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req44C ?? '-',

            [`${IMDA_TS_RG_SEC_4_4_DATA_PROTECTION}-4-4-a`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req44 ?? '-',
            [`${IMDA_TS_RG_SEC_4_4_DATA_PROTECTION}-4-5-b`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentsialGateways?.Req45B ?? '-',
            [`${IMDA_TS_RG_SEC_4_4_DATA_PROTECTION}-4-5-c`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req45C ?? '-',
            [`${IMDA_TS_RG_SEC_4_5_LEVEL2_REQUIREMENTS}-4-5`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req45 ?? '-',

            [`${IMDA_TS_RG_SEC_4_6_VALIDATION_OF_DATA_INPUTS}-4-6`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req46 ?? '-',

            [`${IMDA_TS_RG_SEC_4_7_VULNERABILITIES_REPORTING}-4-7`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGatewaysIssue2?.Req47 ?? '-',


            [`${CYBERSECURITY_LABELLING_SCHEME}-cybersecurity-labelling-scheme`]:
                licenceDetails?.cybersecurityLabellingScheme?.clLevel ?? '-',

            [`${IMDA_TS_SECURITY_REQUIREMENTS_FOR_PABX_DECLARATION_SECTION}-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection ?? '-',

            [`${IMDA_TS_PABX_SEC_4_1_1_FACTORY_PRE_LOADED_LOGIN_CREDENTIALS}-4-1-1-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req411 ?? '-',

            [`${IMDA_TS_PABX_SEC_4_1_2_MINIMUM_PASSWORD_LENGTH}-4-1-2-a-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req412A ?? '-',
            [`${IMDA_TS_PABX_SEC_4_1_2_MINIMUM_PASSWORD_LENGTH}-4-1-2-b-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req412B ?? '-',
            [`${IMDA_TS_PABX_SEC_4_1_2_MINIMUM_PASSWORD_LENGTH}-4-1-2-c-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req412C ?? '-',

            [`${IMDA_TS_PABX_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-a-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req421A ?? '-',
            [`${IMDA_TS_PABX_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-b-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req421B ?? '-',
            [`${IMDA_TS_PABX_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-c-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req421C ?? '-',
            [`${IMDA_TS_PABX_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-d-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req421D ?? '-',

            [`${IMDA_TS_PABX_SEC_4_2_2_INITIAL_SETUP_HANDLING}-4-2-2-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req422 ?? '-',

            [`${IMDA_TS_PABX_SEC_4_2_3_AUTHENTICATION_HANDLING}-4-2-3-a-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req423A ?? '-',
            [`${IMDA_TS_PABX_SEC_4_2_3_AUTHENTICATION_HANDLING}-4-2-3-b-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req423B ?? '-',
            [`${IMDA_TS_PABX_SEC_4_2_3_AUTHENTICATION_HANDLING}-4-2-3-c-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req423C ?? '-',
            [`${IMDA_TS_PABX_SEC_4_2_3_AUTHENTICATION_HANDLING}-4-2-3-d-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req423D ?? '-',

            [`${IMDA_TS_PABX_SEC_4_2_4_PASSWORD_HANDLING}-4-2-4-a-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req424A ?? '-',
            [`${IMDA_TS_PABX_SEC_4_2_4_PASSWORD_HANDLING}-4-2-4-b-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req424B ?? '-',

            [`${IMDA_TS_PABX_SEC_4_2_5_DEVICE_MANAGEMENT_INTERFACE}-4-2-5-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req425 ?? '-',

            [`${IMDA_TS_PABX_SEC_4_3_FIRMWARE_UPDATES}-4-3-a-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req43A ?? '-',
            [`${IMDA_TS_PABX_SEC_4_3_FIRMWARE_UPDATES}-4-3-b-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req43B ?? '-',
            [`${IMDA_TS_PABX_SEC_4_3_FIRMWARE_UPDATES}-4-3-c-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req43C ?? '-',
            [`${IMDA_TS_PABX_SEC_4_3_FIRMWARE_UPDATES}-4-3-d-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req43D ?? '-',
            [`${IMDA_TS_PABX_SEC_4_3_FIRMWARE_UPDATES}-4-3-e-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req43E ?? '-',
            [`${IMDA_TS_PABX_SEC_4_3_FIRMWARE_UPDATES}-4-3-f-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req43F ?? '-',

            [`${IMDA_TS_PABX_SEC_4_4_1_DATA_CONFIDENTIALITY}-4-4-1-a-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req441A ?? '-',
            [`${IMDA_TS_PABX_SEC_4_4_1_DATA_CONFIDENTIALITY}-4-4-1-b-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req441B ?? '-',
            [`${IMDA_TS_PABX_SEC_4_4_1_DATA_CONFIDENTIALITY}-4-4-1-c-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req441C ?? '-',

            [`${IMDA_TS_PABX_SEC_4_4_2_EVENT_NOTIFICATION}-4-4-2-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req442 ?? '-',

            [`${IMDA_TS_PABX_SEC_4_4_3_DATA_BACKUP}-4-4-3-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req443 ?? '-',

            [`${IMDA_TS_PABX_SEC_4_5_SECURING_THE_TRUNK}-4-5-a-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req45A ?? '-',
            [`${IMDA_TS_PABX_SEC_4_5_SECURING_THE_TRUNK}-4-5-b-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req45B ?? '-',
            [`${IMDA_TS_PABX_SEC_4_5_SECURING_THE_TRUNK}-4-5-c-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req45C ?? '-',

            [`${IMDA_TS_PABX_SEC_4_6_VALIDATION_OF_DATA_INPUTS}-4-6-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req46 ?? '-',

            [`${IMDA_TS_PABX_SEC_4_7_1_REPORT_ON_CALLS}-4-7-1-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req471 ?? '-',

            [`${IMDA_TS_PABX_SEC_4_7_2_VULNERABILITY_REPORTING}-4-7-2-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req472 ?? '-'
        }
    };

    return licence;
};

const eserPayload = {
    formatESER
};

export default eserPayload;
